export default function Footer() {
  const year = '2026';
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-4 py-12 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:px-6 md:py-16">
        <div>
          <a href="#top" className="flex items-center gap-2.5">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">看料网</span>
            <span className="rounded-sm bg-primary-500 px-1.5 py-0.5 text-[10px] font-semibold tracking-widest text-background-50">
              旧料档案
            </span>
          </a>
          <p className="mt-4 max-w-sm text-xs leading-6 text-foreground-600">
            看料网专注历史黑料与往期爆料存档的整理与回翻。旧料回顾专区把往年事件、过往大瓜按时间摊开，
            让被遗忘的长期瓜也能连线索一起补齐。
          </p>
          <p className="mt-4 rounded-sm border border-background-200 bg-background-50 px-3 py-2 text-[11px] leading-5 text-foreground-400">
            本站内容均为演示性的栏目归档整理，不构成对任何现实主体的主张；请仅作素材方向参考。
          </p>
        </div>

        <div>
          <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-700">栏目导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li><a href="#speed" className="transition-colors hover:text-primary-600">本期速报</a></li>
            <li><a href="#timeline" className="transition-colors hover:text-primary-600">往年档期</a></li>
            <li><a href="#longgossip" className="transition-colors hover:text-primary-600">长期瓜合集</a></li>
            <li><a href="#oldreview" className="transition-colors hover:text-primary-600">旧料回顾</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-700">归档资源</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li><a href="#person" className="transition-colors hover:text-primary-600">人物档检索</a></li>
            <li><a href="#download" className="transition-colors hover:text-primary-600">入口与下载</a></li>
            <li><a href="#download" className="transition-colors hover:text-primary-600">翻旧账合集</a></li>
            <li><a href="#timeline" className="transition-colors hover:text-primary-600">时间索引</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-700">维护说明</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li><a href="#top" className="transition-colors hover:text-primary-600">回顶部</a></li>
            <li><span>档期维护：每季度整档</span></li>
            <li><span>线索校对：以原件为准</span></li>
            <li><span>最早入档：{year} 前</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/80">
        <div className="mx-auto flex max-w-[1240px] flex-col items-start justify-between gap-2 px-4 py-5 text-[11px] text-foreground-400 sm:flex-row sm:items-center md:px-6">
          <p>© {year} 看料网 · 历史黑料与往期爆料存档 · 仅供演示</p>
          <p className="flex items-center gap-2">
            <i className="ri-archive-line" />
            旧料回顾 · 翻旧账合集 · 连线索一起补齐
          </p>
        </div>
      </div>
    </footer>
  );
}